import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 15 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="animate-slide-down bg-gradient-to-r from-[#8b0000] via-[#c82333] to-[#8b0000] text-white py-3 md:py-4 px-4 text-center relative z-[70] shadow-lg border-b border-red-900/50" data-id="element-525">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-526">
        <span className="text-white/90 text-sm md:text-base tracking-[0.12em] uppercase font-bold" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-527">
          🔥 Oferta por tiempo limitado — Cupos limitados
        </span>
        <div className="flex items-center gap-3" data-id="element-528">
          <div className="flex items-center gap-1" data-id="element-529">
            <span className="bg-white/20 backdrop-blur-sm text-white px-3 py-1.5 rounded-lg text-2xl md:text-3xl font-extrabold tracking-widest leading-none border border-white/20" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.15em'
          }} data-id="element-530">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-white/80 text-xl md:text-2xl font-bold animate-pulse" data-id="element-531">
              :
            </span>
            <span className="bg-white/20 backdrop-blur-sm text-white px-3 py-1.5 rounded-lg text-2xl md:text-3xl font-extrabold tracking-widest leading-none border border-white/20" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.15em'
          }} data-id="element-532">
              {String(seconds).padStart(2, '0')}
            </span>
          </div>
          <a href="#pricing-offer" className="hidden sm:inline-block bg-white text-[#c82333] text-xs md:text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wider hover:bg-gray-100 transition-colors" style={{
          fontFamily: "'Cormorant Garamond', serif"
        }} data-id="element-533">
            ¡Inscribirme ya!
          </a>
        </div>
      </div>
    </div>;
}